<template>
  <div>
    <label class="label-name" :for="label">{{ label }}</label>
    <textarea
      placeholder="Placeholder"
      :value="value"
      :maxlength="maxlength"
      :id="label"
      @input="$emit('input', $event.target.value)"
      @blur="$emit('onChangeValue')"></textarea>
    <div class="text-length">{{ value.length }}/{{ maxlength }}</div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: 'Label',
    },
    value: {
      type: String,
      default: '',
    },
    maxlength: {
      type: Number,
      default: 250,
    },
  },
};
</script>

<style lang="less">
@import '~@eds/vanilla/variables/dark.less';

.text-length {
  margin-top: 0.25rem;
  text-align: right;
  font-size: small;
  color: @gray-46;
}

.label-name {
  margin-bottom: 0 !important;
}
</style>